import { FormattedRecipe } from '@library/menu-service/queries/menuApiRecipes/types'

import { mediaTransformer } from './recipes/mediaTransformer'
import { isFineDineInTransformer, surchargeTransformer } from './recipes/recipeHelpers'

function recipeTransformer({
  normalisedAttributes,
  individualRecipeId,
  uuid,
}: {
  normalisedAttributes: FormattedRecipe['attributes']
  individualRecipeId: string
  uuid: string
}) {
  return {
    boxType: normalisedAttributes.box_type ? normalisedAttributes.box_type.slug : '',
    prepTimes: normalisedAttributes.prep_times,
    coreRecipeId: normalisedAttributes.core_recipe_id.toString(),
    description: normalisedAttributes.description,
    dietType: normalisedAttributes.diet_type ? normalisedAttributes.diet_type.slug : '',
    id: individualRecipeId,
    isFeaturedRecipe: false,
    meals: [
      {
        numPortions: 1,
        surcharge: surchargeTransformer(normalisedAttributes.surcharges.for1 || null),
      },
      {
        numPortions: 2,
        surcharge: surchargeTransformer(normalisedAttributes.surcharges.for2),
      },
      {
        numPortions: 3,
        surcharge: surchargeTransformer(normalisedAttributes.surcharges.for3 || null),
      },
      {
        numPortions: 4,
        surcharge: surchargeTransformer(normalisedAttributes.surcharges.for4),
      },
      {
        numPortions: 5,
        surcharge: surchargeTransformer(normalisedAttributes.surcharges.for5 || null),
      },
    ],
    media: {
      images: mediaTransformer(normalisedAttributes.images, normalisedAttributes.name),
    },
    rating: {
      count: normalisedAttributes.rating ? normalisedAttributes.rating.count : 0,
      average: normalisedAttributes.rating ? normalisedAttributes.rating.average : 0,
    },
    dietaryClaims: normalisedAttributes.dietary_claims,
    isFineDineIn: isFineDineInTransformer(normalisedAttributes),
    title: normalisedAttributes.name,
    foodBrand: normalisedAttributes.food_brand,
    portionSizesOffered: [2, 4],
    uuid,
    calories: normalisedAttributes.calories,
    invalidPreference: normalisedAttributes.invalid_preference,
    protein: normalisedAttributes.protein,
  }
}

/**
 * The goal of this function is to map recipes from menu service
 *
 * @param recipes
 * @returns {*}
 */
function menuRecipeMapper(recipes: FormattedRecipe[]) {
  return recipes.map((recipe) =>
    recipeTransformer({
      normalisedAttributes: recipe.attributes,
      individualRecipeId: recipe.attributes.core_recipe_id,
      uuid: recipe.id,
    }),
  )
}

export { menuRecipeMapper }
